"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _styles = require("@material-ui/core/styles");

var _legacy = require("../../legacy");

// We combine the MUI and Emotion themes and export them as a whole
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return (0, _jsxRuntime.jsx)(_styles.StylesProvider, {
    injectFirst: true,
    children: (0, _jsxRuntime.jsx)(_react.ThemeProvider, {
      theme: theme,
      children: (0, _jsxRuntime.jsx)(_styles.ThemeProvider, {
        theme: (0, _legacy.muiTheme)(theme),
        children: children
      })
    })
  });
};

var _default = ThemeProvider;
exports["default"] = _default;